import './styles.scss';
import Logo from 'icons/SpottedZebraLogo.svg?react';
import { navbarConfig } from 'navigation/AppbarNavigation/MainNavbar.constants';
import { FC, useLayoutEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Logout from './Logout';

const AppBar: FC = () => {
  const location = useLocation();
  const itemRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  const activeIndex = navbarConfig.findIndex(
    route =>
      location.pathname === route.path ||
      location.pathname.startsWith(`${route.path}/`)
  );

  useLayoutEffect(() => {
    if (activeIndex < 0) {
      setIndicator({ left: 0, width: 0 });
      return;
    }
    const item = itemRefs.current[activeIndex];
    if (item) {
      setIndicator({ left: item.offsetLeft, width: item.offsetWidth });
    }
  }, [activeIndex, location.pathname]);

  return (
    <div className="appbar">
      <div className="appbar__left-content">
        <Logo className="appbar__logo" />
        <nav className="appbar__nav">
          {navbarConfig.map((route, i) => (
            <NavLink
              key={route.title}
              ref={el => {
                itemRefs.current[i] = el;
              }}
              className={({ isActive }) =>
                isActive
                  ? 'appbar__nav-item appbar__nav-item_active'
                  : 'appbar__nav-item'
              }
              title={route.title}
              to={route.path}
            >
              <div className="appbar__nav-item-content">{route.title}</div>
            </NavLink>
          ))}
          <div
            className="appbar__nav-indicator"
            style={{ left: indicator.left, width: indicator.width }}
          />
        </nav>
      </div>
      <div>
        <Logout />
      </div>
    </div>
  );
};

export default AppBar;
